<div class="container-fluid reporting-informes-page px-3 px-md-4 py-3">
  <div class="row">
    <div class="col-md-6 mx-auto text-center text-white">
      <app-alert [titulo]="'Informes'"></app-alert>
    </div>
  </div>
  <div class="row my-3">
    <div class="col-12">
      <mat-card class="card-bg card-filters informes-filters-card" [ngClass]="{'ver-mas': verMas}">
        <div class="filter-heading">
          <p class="mb-0">Filtros</p>
        </div>
        <div class="container-fluid px-0">
          <div class="row g-2 mt-2 align-items-center informes-filter-row">
            <div class="col-12 col-sm-6 col-xl-4">
              <mat-form-field #reportList appearance="outline" class="w-100 select-form-field compact-field">
                <mat-label>Reportes</mat-label>
                <mat-select panelClass="report-type-touch-panel" [(ngModel)]="selectedReporte" (selectionChange)="getReporteSelected($event)">
                  <mat-option *ngFor="let reporte of reportesList" [matTooltip]="reporte.NReporte" [value]="reporte">
                    {{ reporte.NReporte }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
            <div class="col-6 col-sm-3 col-xl-2">
              <mat-form-field appearance="outline" class="mat-form-field-date w-100 compact-field">
                <mat-label>Desde</mat-label>
                <input (dateChange)="selectPeriodoDesde($event)" matInput [formControl]="desdeFc"
                  [matDatepicker]="dpStart">
                <mat-datepicker-toggle matSuffix [for]="dpStart"></mat-datepicker-toggle>
                <mat-datepicker #dpStart panelClass="example-month-picker">
                </mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-6 col-sm-3 col-xl-2">
              <mat-form-field appearance="outline" class="mat-form-field-date w-100 compact-field">
                <mat-label>Hasta</mat-label>
                <input (dateChange)="selectPeriodoHasta($event)" matInput [formControl]="hastaFc"
                  [matDatepicker]="dpEnd" [min]="minDate">
                <mat-datepicker-toggle matSuffix [for]="dpEnd"></mat-datepicker-toggle>
                <mat-datepicker #dpEnd panelClass="example-month-picker">
                </mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-xl-2">
              <mat-form-field appearance="outline" class="seccion select-form-field w-100 compact-field">
                <mat-label>Sección</mat-label>
                <mat-select (selectionChange)="getSeccionSelected($event)">
                  <mat-option *ngFor="let item of cmbSectorList" [matTooltip]="item.Nsector" [value]="item.IdSector">
                    {{ item.Nsector }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-xl-2 informe-actions-column">
              <button mat-raised-button color="primary" class="generate-report-button"
                aria-label="Generar informe" matTooltip="Generar informe" (click)="obtenerInforme($event)">
                <mat-icon>search</mat-icon>
                <span>Generar informe</span>
              </button>
            </div>
          </div>
        </div>
        <hr class="line">
        <div class="ver-mas-wrapper">
          <div *ngIf="verMas" class="arrow-up"></div>
          <div *ngIf="!verMas" class="arrow-down"></div>
          <a href="javascript:void(0)" (click)="setVerMas()" class="btn-ver-mas">
            <p class="mt-1">{{ verMas ? 'Menos filtros' : 'Más filtros' }}</p>
          </a>
        </div>
        <div class="container-fluid mt-1" *ngIf="verMas">
          <div class="row">
            <div class="col">
              <div class="d-flex align-items-center legajo-wrapper">
                <mat-slide-toggle [(ngModel)]="seleccionaLegajo" (change)="setSeleccionaLegajo($event)">Colaborador
                  específico</mat-slide-toggle>
                <button *ngIf="seleccionaLegajo" mat-mini-fab class="btn-open-nomina ml-3" color="primary"
                  matTooltip="Buscar colaborador" (click)="openModalNomina()">
                  <mat-icon>search</mat-icon>
                </button>
                <mat-chip-list *ngIf="nomina && seleccionaLegajo" class="ml-3">
                  <mat-chip class="mx-auto position-relative">
                    <span>{{ (nomina.IdLegajo) ? nomina.IdLegajo + ' - ' + nomina.Apellido + ' ' + nomina.Nombre : '-'
                      }}</span>
                  </mat-chip>
                </mat-chip-list>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-slide-toggle [(ngModel)]="esNominaActiva" (change)="setNominaActiva()">Solo nómina
                activa</mat-slide-toggle>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
